import { useNavigate } from 'react-router-dom';

interface HomePageProps {
  restaurantConfig: any;
  currentUser: any;
  onAuthRequired: () => void;
  onLogout: () => void;
}

const HomePage = ({ restaurantConfig, currentUser, onAuthRequired, onLogout }: HomePageProps) => {
  const navigate = useNavigate();

  const handleOrderNow = () => {
    navigate('/menu');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb' }}>
      {/* Header */}
      <header style={{ background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={{ 
          padding: '16px', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <h1 style={{ fontSize: '20px', fontWeight: '700', margin: 0 }}>
            {restaurantConfig?.restaurant_name || 'Restaurant'}
          </h1>
          
          {currentUser ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>
                Hi, {currentUser.name}!
                {currentUser.isGuest && ' (Guest)'}
              </span>
              <button
                onClick={onLogout}
                style={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  background: '#f3f4f6',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Logout
              </button>
            </div>
          ) : (
            <button
              onClick={onAuthRequired}
              className="btn btn-primary"
              style={{ 
                padding: '8px 16px', 
                fontSize: '14px'
              }}
            >
              Login
            </button>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <div style={{ 
        background: 'linear-gradient(135deg, #f97316, #ea580c)', 
        color: 'white',
        padding: '48px 16px',
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px' }}>
          Delicious Food Delivered
        </h2>
        <p style={{ marginBottom: '32px', opacity: 0.9 }}>
          Fresh, hot meals delivered right to your doorstep within 30-45 minutes
        </p>
        <button
          onClick={handleOrderNow}
          className="btn btn-primary"
          style={{
            background: 'white',
            color: '#f97316',
            padding: '12px 32px',
            fontSize: '16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }}
        >
          Order Now
        </button>
      </div>

      {/* Restaurant Info */}
      <div style={{ padding: '32px 16px' }}>
        <div className="card">
          <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>
            Restaurant Information
          </h3>
          
          {restaurantConfig?.phone && (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
              <span style={{ marginRight: '12px', fontSize: '18px' }}>📞</span>
              <div>
                <p style={{ fontWeight: '500', margin: '0 0 4px 0' }}>Phone</p>
                <p style={{ color: '#6b7280', margin: 0 }}>{restaurantConfig.phone}</p>
              </div>
            </div>
          )}

          {restaurantConfig?.address && (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
              <span style={{ marginRight: '12px', fontSize: '18px' }}>📍</span>
              <div>
                <p style={{ fontWeight: '500', margin: '0 0 4px 0' }}>Address</p>
                <p style={{ color: '#6b7280', margin: 0 }}>{restaurantConfig.address}</p>
              </div>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '12px', fontSize: '18px' }}>🕒</span>
            <div>
              <p style={{ fontWeight: '500', margin: '0 0 4px 0' }}>Delivery Time</p>
              <p style={{ color: '#6b7280', margin: 0 }}>30-45 minutes</p>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gap: '16px',
        margin: '0 16px 32px'
      }}>
        <div className="card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>🚚</div>
          <h4 style={{ fontWeight: '500', marginBottom: '4px' }}>Fast Delivery</h4>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>30-45 min</p>
        </div>
        <div className="card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>🔥</div>
          <h4 style={{ fontWeight: '500', marginBottom: '4px' }}>Fresh & Hot</h4>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>Made to order</p>
        </div>
      </div>

      {/* Call to Action */}
      <div style={{ padding: '0 16px 32px' }}>
        <button
          onClick={handleOrderNow}
          className="btn btn-primary"
          style={{ width: '100%', padding: '16px', fontSize: '18px' }}
        >
          View Menu & Order
        </button>
      </div>
    </div>
  );
};

export default HomePage;